import { GzTitleWebComponent } from './component/GzTitleWebComponent';

export { GzTitleWebComponent };

/**
 *  Examples:
 *
 *  Default  => <gz-title>Some text</gz-title>
 *
 *  Default with custom h2 tags => <gz-title><h2>Some text</h2></gz-title>
 *
 *  Title with light font weight and 36px for font size => <gz-title fontWeight='300' fontSize='36'>Some text</gz-title>
 *
 *  Anything added between <gz-title> will be style according to the values passed through
 *  fontWeight and fontSize props
 *
 *  fontSize can take this values 11, 13, 14, 16, 18, 20, 24, 32, 36, 48
 *  fontWeight can take this values 300, 400, 500, 600, 700
 *
 *  For further style we can add other css classes to change the look and feel
 */
